import React from "react"
import Rect from "components/rect"
import { Container } from "@inlet/react-pixi"

const Background = ({ scale, width, height }) => (
  <Container scale={scale}>
    <Rect x={0} y={0} width={width} height={height} color={0} />
  </Container>
)

export default Background
